/**
 * The header's search slot, sized to the room it has (tablet pass 2026-10-20, item 4). At 1024 the
 * slot took what the logo, the location badge and the actions left, down to 7 px. This box is
 * the header's flexible middle (it never depends on what it holds, so measuring it cannot
 * oscillate); with under SEARCH_MIN_WIDTH there the slot is compact: a Search button that expands
 * over the header (SearchSlot). Measured on mount, on resize and on any size change it reports.
 * `compact` forces it (round 2, P1: the mobile layout below 1,024 px, which used the old mobile
 * search); `onExpandedChange` passes through, so the header can set its other controls aside.
 */
import { useLayoutEffect, useRef, useState } from 'react';
import SearchSlot from './SearchSlot';

export const SEARCH_MIN_WIDTH = 160;

export default function HeaderSearchSlot({ compact: forced = false, onExpandedChange }) {
  const roomRef = useRef(null);
  const [narrow, setCompact] = useState(false);
  const compact = forced || narrow;

  useLayoutEffect(() => {
    const el = roomRef.current;
    if (!el || forced) return undefined;
    const measure = () => setCompact(el.getBoundingClientRect().width < SEARCH_MIN_WIDTH);
    measure();
    window.addEventListener('resize', measure);
    let ro = null;
    if (typeof ResizeObserver === 'function') {
      ro = new ResizeObserver(measure);
      ro.observe(el);
    }
    return () => {
      window.removeEventListener('resize', measure);
      if (ro) ro.disconnect();
    };
  }, [forced]);

  return (
    <div
      ref={roomRef}
      data-header-search-room=""
      style={{ flex: '1 1 0', minWidth: '40px', display: 'flex', justifyContent: 'center' }}
    >
      <SearchSlot compact={compact} onExpandedChange={onExpandedChange} />
    </div>
  );
}
